module.exports = __webpack_public_path__ + "img/54.fd3a040a.jpg";